import { UserTier } from 'src/common-services'

const INSIGHTS = [
  // Parcel
  'Property Records',
  'Zoning',
  'Ownership',
  // Area
  'Radius Rings Trade Area',
  'Drive Time Trade Area',
  'Demographics',
  'Car Traffic',
  // Mobility
  'True Trade Area',
  'Location Visits',
  'Custom Polygon Visits',
  'Custom Polygon True Trade Area',
  'Area Visits',
  'Rank',
  'Shopping Center Overview',
  // Other sections
  'Custom Reports',
  'Map Builder',
  'Tenant Finder',
] as const
type Insights = (typeof INSIGHTS)[number]

// Used to reference what insight this route is associated with and its tier
export const INSIGHTS_TIER: Record<Insights, UserTier> = {
  // Parcel
  'Property Records': 'free',
  Zoning: 'intermediate',
  Ownership: 'full',
  // Area
  'Radius Rings Trade Area': 'free',
  'Drive Time Trade Area': 'free',
  Demographics: 'free',
  'Car Traffic': 'entry',
  // Mobility
  'True Trade Area': 'intermediate',
  'Location Visits': 'intermediate',
  'Custom Polygon Visits': 'full',
  'Custom Polygon True Trade Area': 'full',
  'Area Visits': 'intermediate',
  Rank: 'intermediate',
  'Shopping Center Overview': 'full',
  // Other sections
  'Custom Reports': 'entry',
  'Map Builder': 'full',
  'Tenant Finder': 'full',
} as const
